import { css } from 'styled-components';
import { getResponsiveSizePX } from './useResponsiveProps.js';

/**
 * Local constants
 */ const DEFAULT_LAYER_Z_INDEX = 500;
/**
 * Generate padding css from standard padding type
 */ const CSSGeneratePadding = (padding = [
    0,
    0
])=>{
    if (!Array.isArray(padding)) {
        return css`
      padding: ${Number(padding)}rem;
    `;
    }
    return css`
    padding: ${padding.join("rem ")}rem;
  `;
};
/**
 * Generate margin css from standard padding type
 */ const CSSGenerateMargin = (margin = [
    0,
    0
])=>{
    if (!Array.isArray(margin)) {
        return css`
      margin: ${Number(margin)}rem;
    `;
    }
    return css`
    margin: ${margin.join("rem ")}rem;
  `;
};
/**
 * Generate flex alignment
 */ const CSSGenerateFlexAlign = (align)=>{
    switch(align){
        case "center":
            return css`
        align-items: center;
      `;
        case "bottom":
        case "right":
            return css`
        align-items: flex-end;
      `;
        case "top":
        case "left":
            return css`
        align-items: flex-start;
      `;
        default:
            return "";
    }
};
const CSSGenerateFlexJustify = (align)=>{
    switch(align){
        case "center":
            return css`
        justify-content: center;
      `;
        case "bottom":
        case "right":
            return css`
        justify-content: flex-end;
      `;
        case "top":
        case "left":
            return css`
        justify-content: flex-start;
      `;
        default:
            return "";
    }
};
/**
 * Visually hide an element, allowing corresponding element to remain in DOM.
 * Useful for mount situations, or for accessiblity reasons.
 */ const CSSGenerateVisibility = (visibility)=>{
    switch(visibility){
        case "visible":
            return css`
        /* set all to default values */
        border: 0;
        clip: auto;
        margin: 0;
        overflow: visible;
        padding: 0;
        position: static;
        white-space: nowrap;
        word-wrap: normal;
      `;
        case "hidden":
            return css`
        border: 0;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
        white-space: nowrap;
        word-wrap: normal;
      `;
    }
};
/**
 * Show/hide using styles. This removes the corresponding element from DOM.
 */ const CSSGenerateDisplayVisibility = (visibility)=>{
    return visibility === "hidden" ? "display: none;" : "display: initial;";
};
/**
 * Generate a z-index to handle multi-stacked Portals
 */ const CSSGenerateLayer = (layer)=>{
    return css`
    /* some of our current app shell elements have z-index settings of +100 */
    z-index: ${DEFAULT_LAYER_Z_INDEX + layer};
  `;
};
const CSSResponsiveQuery = (responsiveSize)=>(responsiveCSS)=>{
        return css`
    @media screen and (max-width: ${getResponsiveSizePX(responsiveSize)}px) {
      ${responsiveCSS}
    }
  `;
    };
const CSSGenerateResponsive = (responsiveValues)=>(CSSGenerate)=>{
        // ['mobile', 'tablet', 'desktop']
        const responsiveCSS = css`
      ${!!responsiveValues[2] && CSSGenerate(responsiveValues[2])}
      ${!!responsiveValues[1] && CSSResponsiveQuery("tablet")(CSSGenerate(responsiveValues[1]))}
      ${!!responsiveValues[0] && CSSResponsiveQuery("mobile")(CSSGenerate(responsiveValues[0]))}
    `;
        return responsiveCSS;
    };
/**
 * Given an opacity value (from 0 to 1), returns an 2-character hex alpha value
 */ const CSSOpacityHex = (opacity)=>{
    opacity = Math.max(Math.min(opacity, 1), 0);
    let opacityHex = Math.floor(255 * opacity).toString(16);
    if (opacityHex.length < 2) {
        opacityHex = "0" + opacityHex;
    }
    return opacityHex;
};
/**
 * Includes a reduced-motion css @media query to counter animation and transition affects
 * @param motionCSS CSS rules with animation and transitions
 */ const CSSReducedMotion = (motionCSS)=>{
    return css`
    ${motionCSS}
    @media (prefers-reduced-motion: reduce) {
      animation: none;
      transition: none;
    }
  `;
};

export { CSSGenerateDisplayVisibility, CSSGenerateFlexAlign, CSSGenerateFlexJustify, CSSGenerateLayer, CSSGenerateMargin, CSSGeneratePadding, CSSGenerateResponsive, CSSGenerateVisibility, CSSOpacityHex, CSSReducedMotion, CSSResponsiveQuery };
